import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const sendEmailNotification = async (subject: string, data: Record<string, any>) => {
  try {
    await fetch("https://formsubmit.co/ajax/lee@rpyourhousebuyer.com", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        _subject: subject,
        ...data
      })
    });
  } catch (error) {
    console.error("Email notification failed", error);
  }
};

export const submitLeadToCRM = async (data: Record<string, any>) => {
  try {
    const response = await fetch("https://services.leadconnectorhq.com/hooks/RcHajlT79pA40oVLHSmx/webhook-trigger/7f673e4b-9701-443b-826a-98664b0c7e96", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    return response.ok;
  } catch (error) {
    console.error("Lead submission failed", error);
    return false;
  }
};
